import React from 'react';
import { BiCheck } from 'react-icons/bi';

import './services.css';

const renderService = ({ title, info }, i) => (
  <article className="service" key={i}>
    <div className="service__head">
      <h3>{title}</h3>
    </div>
    <ul className="service__list">
      {info.map((text, i) => (
        <li key={i}>
          <BiCheck className="service__list-icon" />
          <p>{text}</p>
        </li>
      ))}
    </ul>
  </article>
);

const services = [
  {
    title: 'ReactJS',
    info: [
      'Redux State Management',
      'User Auth',
      'Social Login',
      'React Query',
    ],
  },
  {
    title: 'NodeJS',
    info: [
      'Express CRUD Operations',
      'Web Scrapping',
      'User Auth',
      'Social Login',
    ],
  },
  {
    title: 'MongoDB',
    info: ['CRUD Operations', 'Auth', 'MongoDB Aggregation Framework'],
  },
];

const Services = () => {
  return (
    <section id="services">
      <h5>What I Offer</h5>
      <h2>Services</h2>

      <div className="container services__container">
        {services.map((service, i) => renderService(service, i))}
      </div>
    </section>
  );
};

export default Services;
